interface UTMParams {
  source?: string;
  medium?: string;
  campaign?: string;
  term?: string;
  content?: string;
}

const setCampaignCookie = (key: string, value: string) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000); // 24 hours
  
  document.cookie = `_dm_rt_${key}=${value};expires=${expires.toUTCString()};domain=${window.location.hostname};path=/`;
};

export const trackCampaignParams = () => {
  const params = new URLSearchParams(window.location.search);
  const utmParams: UTMParams = {};

  // Collect UTM parameters
  ['source', 'medium', 'campaign', 'term', 'content'].forEach(param => {
    const value = params.get(`utm_${param}`);
    if (value) {
      utmParams[param as keyof UTMParams] = value;
      setCampaignCookie(param, value);
    }
  });

  // Send campaign data to analytics
  if (Object.keys(utmParams).length > 0) {
    if (window.gtag) {
      window.gtag('event', 'campaign_received', {
        campaign_source: utmParams.source,
        campaign_medium: utmParams.medium,
        campaign_name: utmParams.campaign,
        campaign_term: utmParams.term,
        campaign_content: utmParams.content
      });
    }

    if (window.dmsnowplow) {
      window.dmsnowplow('trackStructEvent', 'campaign', 'received', 
        utmParams.source || '',
        utmParams.campaign || '',
        utmParams.medium || ''
      );
    }
  }
};
